const isVDP = (dataLayer) => dataLayer?.page?.pageName === 'vdp' || dataLayer?.page?.pg === 'fyc_vdp';

export default isVDP;
